import { render, staticRenderFns } from "./Whatsappbtn.vue?vue&type=template&id=ed2bc468&scoped=true"
import script from "./Whatsappbtn.vue?vue&type=script&lang=js"
export * from "./Whatsappbtn.vue?vue&type=script&lang=js"
import style0 from "./Whatsappbtn.vue?vue&type=style&index=0&id=ed2bc468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2bc468",
  null
  
)

export default component.exports